export function calculateCostShortfall(
  betCostInDollars: number,
  accountBalanceInDollars: number | null,
  isUsingBonusCash: boolean | undefined = false,
  bonusCashBalanceInDollars: number | null
): number {
  const betAmountInCents = Math.round(betCostInDollars * 100)
  const accountBalanceInCents = Math.round((accountBalanceInDollars || 0) * 100)

  // This will always be 0 when the user is not using bonus cash
  const bonusCashBalanceInCents = isUsingBonusCash
    ? Math.round((bonusCashBalanceInDollars || 0) * 100)
    : 0
  const availableBalance = accountBalanceInCents + bonusCashBalanceInCents

  return Math.max(0, (betAmountInCents - availableBalance) / 100)
}
